import { ReactElement } from "react";
import {
  Container,
  SectionDescriptionContainer,
  SectionHeadingContainer,
} from "./style";

interface ISectionDetailsProps {
  heading?: ReactElement | ReactElement[];
  details?: ReactElement | ReactElement[];
  column?: boolean;
}

function SectionDetails({
  heading,
  details,
  column = false,
}: ISectionDetailsProps) {
  return (
    <Container column={column}>
      <SectionHeadingContainer>{heading}</SectionHeadingContainer>
      <SectionDescriptionContainer>{details}</SectionDescriptionContainer>
    </Container>
  );
}

export default SectionDetails;
